<template>
  <div class="d-flex align-items-center justify-content-center" style="height: 100vh;">
    <i class="fa fa-cog fa-spin fa-2x text-muted"></i>
  </div>
</template>

<script>
import { TokenService } from '@/services/storage.service'
import ApiService from '@/services/api.service'
import store from '@/store'
import UserService from '@/services/user.service'

export default {
  name: 'Impersonate',
  async created () {
    const key = this.$route.params.key

    try {
      const response = await ApiService.get(`api/auth/handoff/${key}`)
      const token = response.data.access_token

      TokenService.saveToken(token)
      ApiService.setHeader()

      const userResponse = await UserService.getUser()
      await store.commit('currentUser', userResponse.data)

      this.$router.replace('/')
    } catch (e) {
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>
